import { defineComponent, PropType } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import UploadBox from "../../components/UploadBox";
import { SmeOrderJson } from "../../utils/SmeUtils";
import Utils from "../../utils/Utils";
import Tracking from "../../utils/Tracking";
import SmePhoneForm from "../../components/SmePhoneForm";

export default defineComponent({
    components: {
        SmeLayout,
        UploadBox,
        SmePhoneForm,
    },

    template: `
        <SmeLayout>
            <h1 class="title-1">Niestety nie udało nam się odczytać wszystkich danych z faktury.</h1>

            <div class="SmeSupportFormBox contentbox contentbox--white">
                <SmePhoneForm type="nip.error" @submit="onContactSubmit" button_label="Poznaj ofertę">
                    <p class="SmePhoneFormBox__text">Podaj numer telefon - oddzwonimy i zaprezentujemy Ci najlepszą ofertę.</p>
                </SmePhoneForm>
            </div>

            <div class="StepUpload__box">
                <h2>Wgraj inną fakturę swojej firmy</h2>

                <UploadBox
                    :options="options"
                    :sme="true"

                    label_upload_mobile="Wgraj fakturę Twojej firmy"

                    @back="false"
                    @next="onUploadSubmit"

                    :visible_back="true"
                />
            </div>
        </SmeLayout>
    `,

    emits: [
        'offers'
    ],

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
    },

    setup(props, ctx) {
        function onUploadSubmit() {
            Tracking.doEvent('b2bsme_wrongnip_invoiceupload');

            Utils.setStep(props.options.nextstep);
        }

        function onNextNip() {

        }

        function onContactSubmit() {
            Tracking.doEvent('b2bsme_wrongnip_formsubmitted');
        }

        Utils.hideGreenTerms();

        return {
            onUploadSubmit,
            onNextNip,
            onContactSubmit,
        };
    },
});
